module.exports = __webpack_public_path__ + "img/carousel-next--green.17df1240.svg";